import script from "./AcceptProjectEstimateModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AcceptProjectEstimateModal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__